import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionFourImagesVertical from "hooks/form/blocks/useSectionFourImagesVertical";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { DesktopOrMobile } from "types/enums";

function SectionFourImagesVerticalForm() {
    const {
        buttonDelete,
        setLeftImage,
        setRightImage,
        setCenterLeftImage,
        setCenterRightImage,
        formHook,
    } = useSectionFourImagesVertical();

    const { checkErrorVisibility, form } = formHook;

    useCheckSectionErrors({ formHook });

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <ExtensionsProporsionInfo
                            desktopText={"1000x1500px oppure 1000x1000px (max 400KB)"}
                            mobileText={"667x1000px oppure 667x667px (max 250KB)"}
                            proportion={"quadrata o verticale"}
                        />

                        <GridRow>
                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine a sinistra</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    {" "}
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setLeftImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.left_img.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("left_img.desktop")}
                                        />
                                    </GridItem>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setLeftImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.left_img.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("left_img.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine a destra</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    {" "}
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setRightImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.right_img.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("right_img.desktop")}
                                        />
                                    </GridItem>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setRightImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.right_img.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("right_img.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>

                        <GridRow>
                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine al centro sinistra</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    {" "}
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setCenterLeftImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.center_left_img.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("center_left_img.desktop")}
                                        />
                                    </GridItem>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setCenterLeftImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.center_left_img.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("center_left_img.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine al centro destra</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setCenterRightImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.center_right_img.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility(
                                                "center_right_img.desktop"
                                            )}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setCenterRightImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.center_right_img.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("center_right_img.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionFourImagesVerticalForm;
